import React from 'react';
import enhance from './enhance';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import BodyStyleRow from './BodyStyleRow';
import BodyStyleProgressRow from './BodyStyleProgressRow';

export const QuotaDetails = ({
  dealerInventory,
  processingCenter,
  inTransitToVPC,
  scheduledInProduction,
  producedNotShipped,
  onOrder,
  unsubmitted,
  projectedPipeline,
  currentStatusString,
  recentHistoryFootnote,
  seriesId,
  mini,
  filteredBodyStyleIds,
}) => (
  <div className={styles.main}>
    <div className={styles.statusPanelTitle}>
      <span className={styles.currentStatusString}>{currentStatusString}</span>
      <div className={styles.progressBars}>
        {filteredBodyStyleIds.map(bodyStyleId => (
          <BodyStyleProgressRow
            key={bodyStyleId}
            seriesId={seriesId}
            bodyStyleId={bodyStyleId}
          />
        ))}
      </div>
    </div>
    <div className={styles.allocationSummary}>
      <div className={styles.headings}>
        <span className={styles.column}>{dealerInventory}</span>
        <span className={styles.column}>{processingCenter}</span>
        <span className={styles.column}>{inTransitToVPC}</span>
        <span className={styles.column}>{producedNotShipped}</span>
        <span className={styles.column}>{scheduledInProduction}</span>
        <span className={styles.column}>{onOrder}*</span>
        <span className={styles.column}>{unsubmitted}*</span>
        <span className={styles.column}>{projectedPipeline}</span>
      </div>

      {filteredBodyStyleIds.map(bodyStyleId => (
        <BodyStyleRow
          key={bodyStyleId}
          seriesId={seriesId}
          bodyStyleId={bodyStyleId}
          mini={mini}
        />
      ))}
      <span className={styles.footnote}>*{recentHistoryFootnote}</span>
    </div>
  </div>
);

QuotaDetails.propTypes = {
  currentStatusString: PropTypes.string.isRequired,
  dealerInventory: PropTypes.string.isRequired,
  processingCenter: PropTypes.string.isRequired,
  inTransitToVPC: PropTypes.string.isRequired,
  scheduledInProduction: PropTypes.string.isRequired,
  producedNotShipped: PropTypes.string.isRequired,
  onOrder: PropTypes.string.isRequired,
  unsubmitted: PropTypes.string.isRequired,
  projectedPipeline: PropTypes.string.isRequired,
  recentHistoryFootnote: PropTypes.string.isRequired,
  seriesId: PropTypes.string.isRequired,
  filteredBodyStyleIds: PropTypes.array.isRequired,
};

export default enhance(QuotaDetails);
